<template>
  <CCard>
    <CCardHeader>
      <CampaignViewHeader
        title="Insurance branch codification"
        :disable-member-select="!member"
        :selected-member-id="member"
        :update-member-id-function="changeMember"
      >
        <template slot="action">
          <CButton
            class="mz-button v2-mz-btn ml-2 mr-2"
            color="primary"
            @click="() => saveMappings()"
          >
            {{ $t("Save") }}
          </CButton>
        </template>
      </CampaignViewHeader>
    </CCardHeader>
    <table-component
      :columns="['line_of_business', 'branch_name']"
      :headings="{
          line_of_business: $t('Identified codifications in the declaration'),
          branch_name: $t('Corresponding business sectors by respective branch for Gareat'),
        }"
      :filter-exclude-columns="['line_of_business', 'branch_name']"
      :sort-exclude-columns="['line_of_business', 'branch_name']"
      ref="table"
      :data="line_of_business_labels_list"
    >
      <template #line_of_business="{ row }">
        {{ row }}
      </template>
      <template #branch_name="{ row }">
        <CSelect
          class="mt-2"
          v-model="selected_category_mapping[row]"
          :options="branches_options"
          @update:value="(event) => setCategoryMapping(event, row)"
        />
      </template>
    </table-component>
    <CCardBody>
    </CCardBody>
  </CCard>
</template>

<script>
import CampaignViewHeader from "@/components/CampaignViewHeader";
import {MemberService} from "@/services/members";
import {RiskFilesServices} from "@/services/risk_files";
import {CategoryMappingsServices} from "@/services/category_mappings";

export default {
  name: "MemberMappingView",
  components: {CampaignViewHeader},
  data() {
    return {
      members_options: [],
      member: null,
      line_of_business_labels_list: [],
      branches_options: [],
      selected_branch: undefined,
      selected_category_mapping: {},
    }
  },
  async mounted() {
    const category_mappings_in_db = await CategoryMappingsServices.getAllMemberMappings() || []
    const res = await MemberService.getMembers()
    this.members_options = res.map((member) => ({
      value: member.id_member,
      label: member.name,
    }));
    this.member = Number(this.$route.params.id)
    const category_mapping = await RiskFilesServices.getCategoryMapping(
      this.$route.params.campaignId,
      this.$route.params.id
    )
    this.line_of_business_labels_list = category_mapping?.data?.line_of_business || []
    this.branches_options = category_mapping?.data?.branches.map((branch_data) => ({
      value: branch_data.id_branch,
      label: this.$store.state.language === 'fr' ? branch_data.branch : branch_data.EN
    }))
    this.line_of_business_labels_list.forEach((line_of_business) => {
      const found_category_mapping = category_mappings_in_db.find(
        category_mapping => category_mapping.business_line === line_of_business
      )
      if (found_category_mapping) {
        this.selected_category_mapping[line_of_business] = found_category_mapping.id_branch
      } else {
        this.selected_category_mapping[line_of_business] = this.branches_options[0].value
      }
    })
  },
  methods: {
    changeMember(member_id) {
      this.$router.push({
        name: 'Insurance branch codification',
        params: {campaignId: this.$route.params.campaignId, id: member_id}
      });
    },
    async saveMappings() {
      const data = Object.entries(this.selected_category_mapping).map(([business_line, id_branch]) => {
        return {
          business_line,
          id_branch,
        }
      })
      await CategoryMappingsServices.updateBatchMemberMappings({
        id_campaign: this.$route.params.campaignId,
        id_member: this.$route.params.id,
        campaign_members_data: data
      })
      alert(this.$t('Successfully saved Business Mappings'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            })
    },
    setCategoryMapping(value, row) {
      this.selected_category_mapping[row] = value
    }
  }
}
</script>

<style scoped>

</style>
